import React from "react";
const intl = {
  headline: {
    en: "Tools",
    dk: "Værktøjer"
  },
  block1: {
    headline: {
      en: "THE TOOLS WE USE",
      dk: "Værktøjerne vi bruger"
    },
    subHeadline: {
      en:
        "iLEAD utilizes research based knowledge and develop tools for our clients to generate valuable insight into organizational relations.",
      dk:
        "iLEAD anvender og udvikler værktøjer der tilbyder vores klienter værdifuld indsigt i forskellige organisatoriske forhold."
    },
    body: {
      en: (
        <div
          style={{ lineHeight: " 16px", fontSize: "14px", color: "#8c8c8c" }}
        >
          <strong style={{ color: "#1abc9c", fontWeight: "bold" }}>
            The three important parameters
          </strong>
          <br />
          Leadership is many things and requires a deep knowledge and keen
          understanding of many disciplines. We believe the primary disciplines
          are concentrated under the headlines of Communication, Culture and
          Change.
          <br />
          <br />
          <span style={{ color: "#1abc9c", fontWeight: "bold" }}>
            Communication.
          </span>
          Transactional Analysis{" "}
          <a class="infomark" style={{ color: "#c9c5c5", fontSize: 16 }}>
            ⓘ{" "}
            <span>
              A psychology theory that is based on the idea that one's behaviour
              and social relationships reflect an interchange between parental,
              adult, and childlike aspects of personality established early in
              life.
            </span>
          </a>
          , Dialogue and Feedback - Together they provide an unparalleled
          understanding of why we communicate the way we do, how our
          communication is perceived, and how it can be optimized to support
          intent. <br />
          <br />
          <span style={{ color: "#1abc9c", fontWeight: "bold" }}>
            Culture{" "}
          </span>{" "}
          is an organization’s lifeblood. It provides oxygen to the brain and
          the muscles and enables the body to function. It is culture that
          creates the framework and the relationships that both attract and
          maintain the primary resource of any business: its people. <br />
          <br />
          <span style={{ color: "#1abc9c", fontWeight: "bold" }}>
            Change{" "}
          </span>{" "}
          has many facets and many faces: the appointment of a new manager, the
          implementation of a new strategy, the acquisition of another business
          or entry into a new market. Regardless of size, everything represents
          a change in one form or another, bringing with it new challenges. But
          invariably such matters are informed by a recurrent question: How do I
          make sure that the change I have in mind happens as soon as possible
          in the most cost-effective way?
        </div>
      ),
      dk: (
        <div
          style={{ lineHeight: " 16px", fontSize: "14px", color: "#8c8c8c" }}
        >
          <strong style={{ color: "#1abc9c", fontWeight: "bold" }}>
            De tre vigtige ledelsesparametre
          </strong>
          <br />
          Ledelse er mange ting og kræver kendskab til mange discipliner. Hos
          iLEAD mener vi de primære discipliner kan samles i tre overskrifter
          eller tre områder. Det er kommunikation, det er kultur og det er
          forandringer. <br />
          <br />
          <span style={{ color: "#1abc9c", fontWeight: "bold" }}>
            Kommunikation.
          </span>
          TA{" "}
          <a class="infomark" style={{ color: "#c9c5c5", fontSize: 16 }}>
            ⓘ{" "}
            <span>
              En psykologi teori der er baseret på idéen om at menneskets adfærd
              og sociale relationer reflektere en udvekslende aspekter af
              personligheden mellem henholdsvis en forældre-, voksen- og
              barnerolle der etableres i de tidlige stadier af menneskets liv.
            </span>
          </a>
          , Dialog og Feedback. Tilsammen giver disse tre orienteringer en
          enestående forståelse af hvorfor vi kommunikerer som vi gør, hvordan
          vores kommunikation bliver opfattet, hvad man selv kan gøre for at
          optimere den og hvorledes den understøtter intentioner. <br />
          <br />
          <span style={{ color: "#1abc9c", fontWeight: "bold" }}>
            Kultur{" "}
          </span>{" "}
          er altafgørende for en organisation. Kultur er ikke hjertet der slår,
          men det er det blod der fører ilt til hjerne og muskler. Den ilt der
          får den organisatoriske krop til at fungere. Det er kultur der skaber
          rammerne og de forhold der både tiltrækker og fastholder den primære
          ressource i enhver virksomhed – mennesker. <br />
          <br />
          <span style={{ color: "#1abc9c", fontWeight: "bold" }}>
            Forandring{" "}
          </span>{" "}
          Forandringer har mange facetter; det er alt lige fra en ny mellemleder
          til implementering af ny strategi. Det kan være opkøb af virksomhed
          eller indtog på et nyt marked. Småt som stort – alt repræsenterer en
          ændring i en eller anden form og dermed også en udfordring. Det kunne
          være formet som et centralt spørgsmål: Hvordan sikrer jeg mig at
          forandringen finder sted - hurtigst muligt og billigst muligt?
        </div>
      )
    }
  },
  goToTestButton: {
    en: "GO TO TEST",
    dk: "GÅ TIL TEST"
  },
  divider1: {
    en: "The Self-evaluation",
    dk: "Selvevalueringen"
  },
  block2: {
    headline: {
      en: <strong>LEADERSHIP EVALUATION TOOL</strong>,
      dk: <strong>LEDERSKAB EVALUERINGSVÆRKTØJ</strong>
    },
    body: {
      en: (
        <div>
          Leadership depends upon a wide range of dynamic relationships. In
          order to address them, a leader needs to be empathetic, present and
          focused.
          <br />
          <br />
          A results-oriented leader is one willing to take responsibility,
          motivate and inspire people. One who will stretch their colleagues but
          also give responsibility back to those who make change happen.
          <br />
          <br />
          Our Leadership Evaluation Tool helps you build awareness of how you
          lead. It examines key areas defined by 12 parameters. The findings are
          enhanced by input from three of the people you lead or have a
          professional work relation with.
          <br />
          <br />
          The use of Johari's window{" "}
          <a class="infomark" style={{ color: "#c9c5c5", fontSize: 16 }}>
            ⓘ
            <span>
              A technique that helps people better understand their relationship
              with themselves and others.
            </span>
          </a>{" "}
          identifies what we know about ourselves and what we are blind to.
          Leadership Evaluation highlights the differences between how we
          perceive ourselves and how others experience us. The insights gained
          enable leaders to have more meaningful conversation with colleagues.
          <br />
          <br />
          Try it and let us know what you think. It's completely free of charge
          but not necessarily without personal cost. You might learn something
          important about yourself and your relationships. Enjoy.
        </div>
      ),
      dk: (
        <div>
          Ledelse er karakteriseret af en lang række forhold. Forhold der
          hverken er eksklusive eller endegyldige i deres definition. De er kun
          indikerende for omfanget af lederens evne til at være empatisk,
          nærværende og fokuseret.
          <br />
          <br />
          Fokus bør være på skabelsen af resultater – en skabelse der afhænger
          af lederens evne til både at tage ansvar, motivere og inspirere
          mennesker; men også at stille krav og give noget af det ansvar fra
          sig.
          <br />
          <br />
          En selvevaluering er et værktøj, der giver dig mulighed for at vurdere
          dine leder evner defineret ved 12 parametre samlet under 3
          overskrifter – og samtidig invitere tre andre til at give dig deres
          oplevelse af dig som leder.
          <br />
          <br />
          Johari‘s vindue{" "}
          <a class="infomark" style={{ color: "#c9c5c5", fontSize: 16 }}>
            ⓘ
            <span>
              En teknik der hjælper individer med bedre at forstå deres forhold
              til dem selv og andre.
            </span>
          </a>{" "}
          beskriver blandt andet områder af os selv vi kender og områder vi er
          blinde for. Selvevalueringen åbner op for en beskrivelse af netop den
          forskel; hvordan vi oplever os selv – og hvordan andre oplever os.
          Resultatet giver os en mulighed for at indgå i en mere kvalificeret og
          målrettet dialog med kollegaer, medarbejdere eller ledere om hvad det
          er de ser.
          <br />
          <br />
          Prøv det og lad os høre hvad du synes. Det er gratis – men ikke
          nødvendigvis omkostningsfrit; du kunne blive rigere på vigtig viden om
          dig selv og dine relationer. God fornøjelse.
        </div>
      )
    }
  },
  block3: {
    headline1: {
      en: "CULTURE",
      dk: "KULTUR"
    },
    subheadline1: {
      en: "What is it and why is it so important?",
      dk: "Hvad er det og hvorfor er det så vigtigt?"
    },
    body1: {
      en:
        "We believe that with culture being so important and crucial in an organizations ability to perform it needs much more attention. It requires a continuous and conscious effort to develop a healthy well-functioning culture that support and enhance performance.",
      dk:
        "Vi mener at kultur er så vigtig og essentiel for en organisations evne til at præstere, at den har behov for meget mere opmærksomhed end tilfældet er. Det kræver en kontinuerlig og bevidst indsats at udvikle en sund og velfungerede kultur, der både kan understøtte og forbedre de organisatoriske præstationer."
    },
    headline2: {
      en: "COMMUNICATION",
      dk: "KOMMUNIKATION"
    },
    subheadline2: {
      en: "Build relations for collaborative results",
      dk: "Bygge relationer for fællers resultater"
    },
    body2: {
      en:
        "Communication has so many forms – especially with the explosion in digital formats. It is verbal and non-verbal. It tacit and implicit. It‘s obvious and hidden. Its conscious and subconscious or even unconscious. Whatever form it takes it creates and maintains relations between organizational members. In other words – its crucial to get right.",
      dk:
        "Kommunikation har mange udtryksformer –især med eksplosionen i de digitale formater. Den kan være både verbal og non-verbal. Eksplicit og implicit. Åbenlys og skjult. Den kan have afsæt i vores bevidsthed eller underbevidsthed – eller i det ubevidste. Uanset hvilken form den antager, så skaber den og vedligeholder relationer mellem organisatoriske medlemmer. Med andre ord –det er livsvigtigt at knække koden og gøre det rigtigt."
    },
    headline3: {
      en: "CHANGE",
      dk: "FORANDRING"
    },
    subheadline3: {
      en: "Unavoidable and challenging. Why is it so hard?",
      dk: "Uundgåeligt og udfordrende. Hvorfor er det så svært?"
    },
    body3: {
      en:
        "We believe that with the right approach you can actually accelerate your change process – AND – get a better implementation result. It’s a myth that only 30% of change initiatives succeed.  iLEAD  have done some ground breaking research that allows for better and faster implementions.",
      dk:
        "Vi mener at forandringsprocesser faktisk kan implementeres hurtigere og mere effektivt –med den rette tilgang og forståelse – og med bedre resultat! Det er en myte at kun 30% af forandringsinitiativer lykkedes. iLead A/S har med sin forskning på området afdækket hvad der kræves for at skabe bedre forandringsresultater – hurtigere."
    }
  },
  block4: {
    headline: {
      en: "Our approach is based on three solid elements",
      dk: "Vores tilgang er baseret på tre solide elementer:"
    },
    body: {
      en: (
        <div>
          <span style={{ color: "#1abc9c" }}>A strong experience base</span>
          <br />
          Our consultants have considerable practical experience of leadership
          and management themselves, at home and abroad across a range of
          industries in the private and public sectors. <br />
          <br />
          <span style={{ color: "#1abc9c" }}>
            Scientifically based methods and research
          </span>
          <br />
          Our approach builds on research-based and scientific methods. In this
          way, we create value and differentiate ourselves. Not just through
          knowledge and deep understanding of organizations, groups and
          relationships, but also of the relational dynamics that define them.
          <br />
          <br />
          <span style={{ color: "#1abc9c" }}>Diagnostics </span>
          <br />
          Organizational diagnostics are about collecting data, make
          observations and forming hypotheses about organizational processes,
          systems and structures. Intervention and facilitation test these
          hypotheses. They generate a thorough and in-depth picture of the
          organizational dynamics and their implications. Simply put, it is all
          about the quality of relationships. Good or bad, the difference is in
          whether the group functions or not. Does it deliver the results it
          should?
        </div>
      ),
      dk: (
        <div>
          <span style={{ color: "#1abc9c" }}>Et stærkt erfaringsgrundlag;</span>
          <br />
          Vores konsulenter har selv stor praktisk erfaring med ledelse – både
          nationalt og internationalt og fra en lang række forskellige
          industrier, både i det private og det offentlige. <br />
          <br />
          <span style={{ color: "#1abc9c" }}>
            Videnskabeligt forankrede metoder og forskning;
          </span>
          <br />
          Vores tilgang bygger på forsknings-baserede og videnskabeligt
          forankrede metoder. Med dette adskiller vi os og skaber værdi. Både
          gennem viden og gennem dyb forståelse af organisationer, grupper og
          individer samt de relationelle dynamikker som præger dem i deres
          adfærd.
          <br />
          <br />
          <span style={{ color: "#1abc9c" }}>Diagnosticering;</span>
          <br />
          Organisatorisk diagnosticering handler om analyse af data,
          observationer og kortlægning af organisationens processer, systemer og
          strukturer hvad der foregår i dem. Derefter testes disse gennem
          interventioner og facilitering således at der dannes et præcist
          billede af organisatoriske dynamikker og deres indvirkning på
          opgaveløsningen. Udtrykt helt enkelt handler det om relationer og
          kvaliteten af dem. God eller dårlig så er forskellen hvorvidt gruppen
          fungerer eller ej; om resultaterne leveres og dermed om organisationen
          præsterer.
        </div>
      )
    }
  },
  block5: {
    subheadline: {
      en: "LIFE IS ABOUT OPPORTUNITIES",
      dk: "LIVET HANDLER OM MULIGHEDER"
    },
    headline: {
      en: (
        <span>
          The opportunities around us are infinite. If only we dare to look for
          them, and have courage to do what it takes, whether it's change of
          direction, structure or event strategy. <br />
          <br />
          Well, sometimes it's just ourselves we need to change!
        </span>
      ),
      dk: (
        <span>
          Mulighederne omkring os er uendelige. Hvis vi tør kigge op og har
          modet til gøre det, der kræves. Uanset om det er at ændre retning,
          struktur – eller strategi! <br />
          <br /> og nogle gange er det 'bare' os selv der skal turde forandring!
        </span>
      )
    }
  }
};

export default intl;



// WEBPACK FOOTER //
// ./src/pages/OurTool/intl.js